export const DotSolidIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#34932F', size = 10 }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='8' fill={color} />
  </svg>
)

export const DotOutlineIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#34932F', size = 10 }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='8' cy='8' r='7' stroke={color} strokeWidth='1.5' />
  </svg>
)

export const DotStripedIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#34932F', size = 10 }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <defs>
      {/* Define the striped pattern */}
      <pattern id='striped-pattern' patternTransform='rotate(-45)' width='4' height='4' patternUnits='userSpaceOnUse'>
        <rect width='2' height='4' fill={color}></rect>
      </pattern>
    </defs>

    {/* The main circle shape, filled with the striped pattern */}
    <circle cx='8' cy='8' r='8' fill='url(#striped-pattern)'></circle>

    {/* An optional outer ring of the same color can help define the edge */}
    <circle cx='8' cy='8' r='7.5' stroke={color} strokeWidth='1'></circle>
  </svg>
)
